module.exports = __webpack_public_path__ + "img/31.3dfa6c61.jpg";